exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".events-list{max-width:342px;margin:0 auto}@media(min-width: 1160px){.events-list{max-width:100%}}.events-list h3{margin-bottom:16px;font-size:18px;font-weight:500;font-style:normal;font-stretch:normal;line-height:1.33;color:#333}@media(min-width: 1160px){.events-list h3{font-size:24px;line-height:1.67}}.events-list__expand-btn{margin-top:24px;font-size:15px;font-weight:500;font-style:normal;font-stretch:normal;line-height:1.33;letter-spacing:normal;color:#c31b1c;background-color:rgba(0,0,0,0);border:none;cursor:pointer;outline:none}.events-list__error{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100px;padding:10px;font-size:18px;line-height:1.33;color:#909090}@media(min-width: 1160px){.events-list__error{height:134px;padding:32px;font-size:24px;line-height:1.67}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/main/userprofile/events-list/style.scss
// module id = 1445
// module chunks = 58